/* 桌面礼赠分类切换：仅改变可见面板，手机继续展示原有场合导航。 */
(function () {
  if (window.__pdpOccasionDesktopReady) return;
  window.__pdpOccasionDesktopReady = true;
  const instances = new WeakMap();
  function init(root) {
    if (instances.has(root)) return;
    const tabs = [...root.querySelectorAll('[data-po-tab]')];
    if (!tabs.length) return;
    const controller = new AbortController();
    const options = { signal: controller.signal };
    const desktop = matchMedia('(min-width: 750px)');
    let selected = 'occasion';
    function update() {
      root.dataset.poActive = desktop.matches ? selected : 'occasion';
      tabs.forEach(tab => {
        const active = tab.dataset.poTab === selected;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        const panel = root.querySelector('#' + CSS.escape(tab.getAttribute('aria-controls')));
        if (!panel) return;
        if (desktop.matches) {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tab.id);
        } else {
          panel.removeAttribute('role');
          panel.removeAttribute('aria-labelledby');
        }
      });
    }
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        if (!desktop.matches) return;
        selected = tab.dataset.poTab;
        update();
      }, options);
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault();
        tabs[next].focus();
        tabs[next].click();
      }, options);
    });
    desktop.addEventListener('change', update, options);
    update();
    instances.set(root, controller);
  }
  const scan = scope => {
    if (scope.matches?.('[data-po-desktop-tabs]')) init(scope);
    scope.querySelectorAll('[data-po-desktop-tabs]').forEach(init);
  };
  const dispose = scope => {
    const roots = [...scope.querySelectorAll('[data-po-desktop-tabs]')];
    if (scope.matches?.('[data-po-desktop-tabs]')) roots.push(scope);
    roots.forEach(root => {
      instances.get(root)?.abort();
      instances.delete(root);
    });
  };
  scan(document);
  // 预览热更新可能在 section 插入完成前执行脚本，也可能不派发编辑器事件。
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  }
  new MutationObserver(records => {
    records.forEach(record => {
      record.removedNodes.forEach(node => {
        if (node.nodeType === 1 && !node.isConnected) dispose(node);
      });
      record.addedNodes.forEach(node => {
        if (node.nodeType === 1) scan(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => dispose(event.target));
})();
